import React from 'react';
import { motion } from 'framer-motion';
import Icon from '../../../components/AppIcon';

const AnnouncementBar = () => {
  return (
    <motion.div
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      style={{ backgroundColor: '#cf1963' }}
      className="fixed top-0 left-0 right-0 z-[60] text-white py-2 px-4 text-center">
      <div className="max-w-7xl mx-auto flex items-center justify-center space-x-2">
        <Icon name="MapPin" size={16} className="flex-shrink-0" />
        <p className="text-sm font-body font-semibold">Come visit us in our new location in Durham!

        </p>
      </div>
    </motion.div>
  );

};

export default AnnouncementBar;